import React from 'react';
import TimeAgo from 'react-timeago'

const renderPendingRequest = count => {
  if (count < 1) return 'No pending requests.';
  if (count === 1) return `${count} pending request.`;
  return `${count} pending requests.`;
}

const SelectionStatusBox = ({ assigned_credits, pending_request_count = 0, last_login, is_eliciting, courses_preference }) => (
  <div className="sidebar-container">
    <div className="sidebar-header">Class Assignment Status</div>
    <div className="progress-box mt-4">
      <span>{`${assigned_credits} credits`}</span>
      <p>{renderPendingRequest(pending_request_count)}</p>
      {!last_login && <p>This student has never logged in</p>}
      {last_login && <p>Last logged in <TimeAgo date={last_login} /></p>}
      {!is_eliciting && courses_preference &&
        courses_preference.length > 0 &&
        <p>Rankings last updated <TimeAgo date={courses_preference[0].created_at} /></p>}
    </div>
  </div>
);

SelectionStatusBox.defaultProps = {
  pending_requests: []
}

export default SelectionStatusBox;


// WEBPACK FOOTER //
// ./src/components/students/SelectionStatusBox.js